import React, { ReactElement } from 'react';
import HistogramItem from './histogram-item/histogram-item';
import { CategoryAggregationsInterface } from 'modules/categories/interfaces/category-aggregations.interface';

import './histogram.scss';

const Histogram: React.FC<{ aggregations: CategoryAggregationsInterface; min: number; max: number; }> = ({ aggregations, min, max }): ReactElement | null => {
    return (
        <div className="histogram">
            {
                aggregations.histogram.map(item => <HistogramItem key={item.min} item={item} count={aggregations.count}
                    min={min} max={max}
                />)
            }
        </div>
    );
};

export default Histogram;
